import { z } from 'zod';

export const notifyRoutingPlanSchema = z.object({
  routing_plan_id: z.string(),
  routing_plan_name: z.string().regex(/[A-Za-z0-9]/, {
    message: 'Routing plan name must have one alphanumeric character',
  }),
  status: z.enum(['DRAFT', 'COMPLETED', 'LEGACY']),
});

export type NotifyRoutingPlan = z.infer<typeof notifyRoutingPlanSchema>;

export const notifyRoutingPlansSchema = z.array(notifyRoutingPlanSchema);
export type NotifyRoutingPlans = z.infer<typeof notifyRoutingPlansSchema>;
